import { createAsyncThunk } from '@reduxjs/toolkit';
import { ILinkAssetType } from '__generated__/api';
import { IBondGelemMarketReport, SELECT_BOND_GELEM_MARKET_REPORT } from 'services/bonds-helper';
import { dateFormat } from 'utils/dates';
import { API, parseErrorData } from 'utils/service';
import { multiplyBondRowItems } from '../../utils/bonds';
import { AppAsyncThunkConfig } from '../index';
import { PREFIX } from './helpers';
import { selectorsReportYieldLinkedMarket } from './selectors';

export const actionReportYieldLinkedMarketFetch = createAsyncThunk<
  Array<IBondGelemMarketReport>,
  void | { initDate: string },
  AppAsyncThunkConfig
>(`${PREFIX}/actionReportYieldLinkedMarketFetch`, async (_, { getState }) => {
  try {
    const { date } = selectorsReportYieldLinkedMarket.filters(getState());
    const { data } = await API.api.bondsHelperGetGelemBondMarketItemsDynamicCreate({
      select: SELECT_BOND_GELEM_MARKET_REPORT,
      date: dateFormat(date, 'yyyy-MM-dd'),
      linkAssetType: ILinkAssetType.CPI,
    });

    return data.items.map(multiplyBondRowItems) as unknown as Array<IBondGelemMarketReport>;
  } catch (e: unknown) {
    throw parseErrorData(e);
  }
});
